import React from 'react';
import { Link } from 'react-router-dom';
const Special = () => {
  return (
    <div className="min-h-screen px-4 py-12 bg-gradient-to-br from-purple-100 via-pink-50 to-yellow-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 transition duration-300">
      <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden flex flex-col md:flex-row items-center">

        {/* Image Section */}
        <div className="md:w-1/2 flex justify-center items-center p-4">
          <img
            src="https://images.unsplash.com/photo-1607746882042-944635dfe10e?q=80&w=600&auto=format&fit=crop"
            alt="Special Educator"
            className="w-full max-w-sm h-auto rounded-lg object-cover shadow-md"
          />
        </div>

        {/* Content Section */}
        <div className="md:w-1/2 p-4 md:p-6 flex flex-col justify-center">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 dark:text-white mb-4 text-center md:text-left">
            🌟 Our Expert Educators for Your Child’s Holistic Growth 🌟
          </h1>
          <p className="text-base text-gray-700 dark:text-gray-300 mb-4 leading-relaxed">
            <strong>Empowering Every Child with Skills Beyond Academics</strong><br /><br />
            {/* We believe every child is unique and deserves personalized attention. Our certified special educators work closely with children having learning disabilities, autism, ADHD, speech delays, and other challenges. */}
            We believe in inclusive education for all children. Our team includes special educators, shadow teachers, speech and occupational therapist, along with vocational training support. 
          </p>

          {/* Services Include */}
          <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 shadow-inner mb-6">
            <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">👩‍🏫 Services Include:</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-200 text-sm">
              <li>👥 One-on-one learning support</li>
              <li>🗣️ Behavior and communication therapy</li>
              <li>📋 IEP (Individualized Education Plan) design</li>
              <li>📈 Regular progress tracking with parents</li>
            </ul>
          </div>
          <div className="w-full flex flex-col sm:flex-row items-center justify-center gap-4 mt-6">
            <Link to="/contact">
              <button className="bg-pink-600 hover:bg-pink-700 text-white text-sm font-medium px-6 py-3 rounded-md shadow transition duration-300 w-64 sm:w-auto">
                Schedule a Free Consultation
              </button>
            </Link>
            <a
              href="https://wa.me/919999999999"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white text-sm font-medium px-6 py-3 rounded-md shadow transition duration-300 w-64 sm:w-auto text-center"
            >
              📲 Connect on WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Special;
